import React from 'react'
import DatePicker from 'react-datepicker'

import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgyCheckbox from 'app/components/util/lgy-checkbox/BasicLgyCheckbox'

import 'react-datepicker/dist/react-datepicker.css'
import '../style/alert-settings.scss'


const AlertSettings = ({ id, type, headline, byline, endTime, errors, handleChange, handleDateChange, handleInvalid, handleCancel, saveAlert, deleteAlert, toggleSettings, isSettingsOpen }) =>
  <div className='alert-settings'>
    <form autoComplete='off' onSubmit={(event) => {
      event.preventDefault()
      saveAlert(id, type, headline, byline, endTime)
      toggleSettings(!isSettingsOpen)
    }}>
      <div>
        <fieldset className='usa-fieldset-inputs usa-sans'>
          <legend className='usa-sr-only'>Select Alert Type</legend>
          <ul className='usa-unstyled-list'>
            <li>
              <BasicLgyCheckbox id='info' type='radio' name='type' label='Info' value='info' checked={type === 'info'} onChange={handleChange}
                error={errors.type} onInvalid={handleInvalid} autoFocus required />
            </li>
            <li>
              <BasicLgyCheckbox id='warning' type='radio' name='type' label='Warning' value='warning' checked={type === 'warning'} onChange={handleChange} />
            </li>
            <li>
              <BasicLgyCheckbox id='success' type='radio' name='type' label='Success' value='success' checked={type === 'success'} onChange={handleChange} />
            </li>
            <li>
              <BasicLgyCheckbox id='error' type='radio' name='type' label='Error' value='error' checked={type === 'error'} onChange={handleChange} />
            </li>
          </ul>
        </fieldset>
      </div>
      <div className='text-controls'>
        <fieldset className='usa-fieldset-inputs usa-sans'>
          <legend className='usa-sr-only'>Enter Alert Details</legend>
          <BasicLgyInputField id='headline' name='headline' label='Headline' type='text' required value={headline} onChange={handleChange} onInvalid={handleInvalid} error={errors.headline} />
          <BasicLgyInputField id='byline' name='byline' label='Byline' type='text' value={byline} onChange={handleChange} />
          <div className={errors.endTime ? 'usa-input-error' : 'date-input-field'}>
            <label htmlFor='endTime' className='usa-input-optional'>End Date and Time (CST)</label>
            {errors.endTime && <span className='usa-input-error-message' role='alert'>{errors.endTime}</span>}
            <DatePicker id='endTime' name='endTime' selected={endTime} onChange={handleDateChange} placeholderText='All times are CST'
              showTimeSelect timeIntervals={15} minDate={new Date()} dateFormat='MMMM d, yyyy h:mm aa' />
          </div>
        </fieldset>
      </div>
      <div className='button-controls'>
        <button id='save' className='usa-button' type='submit'>Save</button>
        <button id='cancel' className='usa-button-secondary cancel' type='button' onClick={handleCancel}>Cancel</button>
        <button id='delete' className='usa-button-red' type='button' disabled={!!!id} onClick={() => { deleteAlert(id); toggleSettings(!isSettingsOpen) }}>Delete</button>
      </div>
    </form>
  </div>

export default AlertSettings
